module.exports = __webpack_public_path__ + "static/img/11.fd7f593.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/11.png
// module id = 8tOS
// module chunks = 0